(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shop-the-set"] && !Shopify.designMode) return;
  try {
    const updateSetImages = (select) => {
    const set = select.closest('.shop-the-sets__set');
    const option = select.selectedOptions[0];
    const imageOption = option?.dataset.imageOption;
    if (!set || !imageOption) return;

    set.querySelectorAll('[data-set-image-source]').forEach((source) => {
      if (source.dataset.option !== imageOption) return;

      const productId = source.dataset.productId;
      const cardImage = set.querySelector(`[data-set-product-image="${productId}"]`);
      const visualImage = set.querySelector(`[data-set-visual-image="${productId}"]`);

      if (cardImage && source.dataset.cardSrc) {
        cardImage.src = source.dataset.cardSrc;
        cardImage.removeAttribute('srcset');
        cardImage.alt = source.dataset.cardAlt || '';
      }

      if (visualImage && source.dataset.visualSrc) {
        visualImage.src = source.dataset.visualSrc;
        visualImage.removeAttribute('srcset');
        visualImage.alt = source.dataset.visualAlt || '';
      }

      if (source.dataset.variantUrl) {
        set.querySelectorAll(`[data-set-product-link="${productId}"]`).forEach((link) => {
          link.href = source.dataset.variantUrl;
        });
      }
    });

    const heroImage = set.querySelector('[data-set-hero-image]');
    const heroSource = Array.from(set.querySelectorAll('[data-set-hero-source]')).find(
      (source) => source.dataset.option === imageOption
    );

    if (heroImage && heroSource?.dataset.src) {
      heroImage.src = heroSource.dataset.src;
      heroImage.removeAttribute('srcset');
      heroImage.alt = heroSource.dataset.alt || '';
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bundle-variant]');
    if (!select) return;

    const choice = select.closest('[data-bundle-choice]');
    const bundle = select.closest('.shop-the-sets__bundle');
    const option = select.selectedOptions[0];
    const addButton = choice?.querySelector('[data-bundle-add]');
    const price = bundle?.querySelector('[data-bundle-price]');
    const saving = bundle?.querySelector('[data-bundle-saving]');

    if (addButton) addButton.href = select.value;
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (saving && option?.dataset.saving) saving.textContent = option.dataset.saving;
    updateSetImages(select);
  });

  document.querySelectorAll('[data-bundle-variant]').forEach(updateSetImages);
  } catch(e) { console.error(e); }
})();

})();
